import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { DeleteClientDocument } from "../../__generated__/graphql";

export function useDeleteClient() {
  const [mutate, state] = useMutation(DeleteClientDocument);

  const deleteClient = useCallback(
    async (id: string) => {
      const { data } = await mutate({ variables: { input: { id } } });
      return Boolean(data?.deleteClient?.result);
    },
    [mutate],
  );

  return [deleteClient, state] as const;
}
